import { createReducer } from 'redux-create-reducer'
import type { BusinessInvite } from 'types/user'
import {
  BUSINESS_INVITE_CANCEL,
  BUSINESS_INVITE_CANCEL_FAIL,
  BUSINESS_INVITE_CANCEL_SUCCESS,
  BUSINESS_INVITE_LOAD,
  BUSINESS_INVITE_LOAD_FAIL,
  BUSINESS_INVITE_LOAD_SUCCESS,
  BUSINESS_INVITE_RESEND,
  BUSINESS_INVITE_RESEND_FAIL,
  BUSINESS_INVITE_RESEND_SUCCESS,
  BUSINESS_INVITE_SEND_SUCCESS,
} from '@disco/constants/ActionTypes'
export type BusinessInvitesState = {
  loading: boolean
  loaded: boolean
  invites: Record<number, BusinessInvite>
}
const initialState: BusinessInvitesState = {
  loading: false,
  loaded: false,
  invites: {},
}

function update(state, id, updater) {
  const original = state.invites[id]
  return {
    ...state,
    invites: {
      ...state.invites,
      [id]: { ...original, ...updater() },
    },
  }
}

export const businessInvitesReducer = createReducer<BusinessInvitesState, any>(
  initialState,
  {
    [BUSINESS_INVITE_LOAD](state) {
      return { ...state, loading: true }
    },

    [BUSINESS_INVITE_LOAD_SUCCESS](state, { businessInvites }) {
      const update = {}
      businessInvites.forEach(invite => {
        update[invite.id] = invite
      })
      return {
        ...state,
        loading: false,
        loaded: true,
        invites: { ...state.invites, ...update },
      }
    },

    [BUSINESS_INVITE_LOAD_FAIL](state) {
      return { ...state, loading: false }
    },

    [BUSINESS_INVITE_SEND_SUCCESS](state, { businessInvites }) {
      const update = {}
      businessInvites.forEach(invite => {
        update[invite.id] = invite
      })
      return { ...state, invites: { ...state.invites, ...update } }
    },

    [BUSINESS_INVITE_RESEND](state, { businessInviteId }) {
      return update(state, businessInviteId, () => ({
        resending: true,
        resendingError: null,
      }))
    },

    [BUSINESS_INVITE_RESEND_SUCCESS](state, { businessInviteId }) {
      return update(state, businessInviteId, () => ({
        resending: false,
        resent: true,
      }))
    },

    [BUSINESS_INVITE_RESEND_FAIL](state, { businessInviteId, error }) {
      return update(state, businessInviteId, () => ({
        resending: false,
        resendingError: error,
      }))
    },

    [BUSINESS_INVITE_CANCEL](state, { businessInviteId }) {
      return update(state, businessInviteId, () => ({
        cancelling: true,
        cancellingError: null,
      }))
    },

    [BUSINESS_INVITE_CANCEL_SUCCESS](state, { businessInviteId }) {
      return update(state, businessInviteId, () => ({
        cancelling: false,
        cancelled: true,
      }))
    },

    [BUSINESS_INVITE_CANCEL_FAIL](state, { businessInviteId, error }) {
      return update(state, businessInviteId, () => ({
        cancelling: false,
        cancellingError: error,
      }))
    },
  },
)
